<div class="modal-body  col-sm-12 form-group">
    <form [formGroup]="EscalationEntry" (ngSubmit)="onEscalationSubmit(EscalationEntry.value);">
        <div class="card">
            <div class="card-body">
                <div class="col-sm-3 height-34">Feature / Report</div>
                <input type="hidden" [formControlName]="'ReportID'" [(ngModel)]="this.ReportID" />
                <input type="hidden" [formControlName]="'UserID'" [(ngModel)]="this.UserID" />
                <div class="col-sm-8 height-34">{{this.EscalationData.FeatureDs}}</div>
                <div class="col-sm-3 height-34">Employee</div>
                <div class="col-sm-8" style="padding-top:5px;">
                    <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="false"
                        [formControlName]="'Employee'" bindLabel="UserName" [selectableGroup]="true"
                        [closeOnSelect]="true" bindValue="ID" [(ngModel)]="this.EscalationData.UserID">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                        </ng-template>
                    </ng-select>
                </div>

                <!-- Non User -->
                <div class="col-sm-3 height-34">Non User</div>
                <div class="col-sm-8" style="padding-top:5px;">
                    <input class="form-control" formControlName="NonUser" placeholder="Enter Email (,)" name="NonUser"
                        type="text" value="">
                </div>
                <!-- Non User -->
                <div class="col-sm-3 height-34">Email Setting</div>
                <div class="col-sm-8" style="padding-top:5px;">
                    <table>
                        <tr>
                            <th>Level</th>
                            <th>Days</th>
                            <th>Interval</th>
                            <th>Send Mail To</th>
                        </tr>

                        <tr *ngFor="let ED of EscalationData.EDList; let i=index">
                            <td nowrap width="15%">
                                Level {{ED.LevelID}}
                            </td>

                            <td width="15%">
                                <input type="hidden" value={{ED.ID}} [formControlName]="'ID_'+ED.LevelID" />
                                <input type="hidden" value={{ED.LevelID}} [formControlName]="'LevelID_'+ED.LevelID" />
                                <input type="hidden" value={{ED.recEnable}}
                                    [formControlName]="'recEnable_'+ED.LevelID" />
                                <input type="text" class="form-control" value={{ED.Days}}
                                    [formControlName]="'Day_'+ED.LevelID" />
                            </td>

                            <td width="15%">
                                <input type="text" class="form-control" [value]="ED.Interval"
                                    [formControlName]="'Interval_'+ED.LevelID" />
                            </td>
                            <td width="55%">
                                <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true"
                                    [formControlName]="'Users_'+ED.LevelID" bindLabel="UserName"
                                    [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID"
                                    [(ngModel)]="ED.EmailEmployee">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                                    </ng-template>
                                </ng-select>
                            </td>
                    </table>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-primary submit-btn small " type="submit">
                Save
            </button>
        </div>
    </form>
</div>